import styles from "./HeaderEstetic.module.scss";
import esteticPicture from '../../../shared/assets/photo/estetic/estetic.png';
import esteticPicture_2x from '../../../shared/assets/photo/estetic/estetic_2x.png';
import { Stack } from "../../../shared/ui/Stack/Stack";
import { Text } from "../../../shared/ui/Text/Text";
import esteticPictureMob from '../../../shared/assets/photo/estetic/esteticMob.png';
import esteticPictureMob_2x from '../../../shared/assets/photo/estetic/esteticMob_2x.png';

import gsap from 'gsap';
import { useGSAP } from '@gsap/react';

gsap.registerPlugin(useGSAP);

const HeaderEstetic = () => {

    useGSAP(() => {
        gsap.fromTo(".estetic__header", {opacity: 0,  y:10,}, 
                                    { opacity: 1,
                                    y:0,  
                                    duration: 1, 
                                    });
    }, [])

    return ( 
        <div>
            <div className={styles.content}>
                <img className={styles.picture} src={esteticPicture}
                    srcSet={`${esteticPicture_2x} 2x`} alt="эстетическая стоматология" />
                <img className={styles.pictureMob} src={esteticPictureMob}
                    srcSet={`${esteticPictureMob_2x} 2x`} alt="эстетическая стоматология" />
            <Stack              
                justifyContent='justifyCenter'
                alignItems ='alignCenter'
                className={styles.header}>
                    <Text
                        type='h1' 
                        size ='xxl'
                        className={`estetic__header ${styles.title}`}>
                            Профилактика, гигиена и эстетическая стоматология
                    </Text>
            </Stack>
            </div>
        </div>
    );
}
export default HeaderEstetic;